/**
 * The analyst marks of a selected relationship (PRD-0075 R-C4): *Už neplatí od* and *Chybné*, each
 * reversible, by the element id the view holds the edge under.
 */
import { useMemo } from 'react'
import { toInvalidateRequest } from './fact-forms'
import { relationshipInvalidation, retirementOf } from './fact-marks'
import { MarkDialog } from './MarkDialog'
import { RelationshipFactsView } from './RelationshipFactsView'
import { useMarkDialogs } from './useMarkDialogs'

export interface RelationshipFactsProps {
  caseId: string
  relationship: { id: string; properties?: Record<string, unknown> }
}

export function RelationshipFacts({ caseId, relationship }: RelationshipFactsProps) {
  const { id, properties } = relationship
  const marks = useMemo(
    () => ({
      invalidation: relationshipInvalidation(properties ?? {}),
      retirement: retirementOf(properties ?? {}),
    }),
    [properties]
  )
  const dialogs = useMarkDialogs<'invalidateRelationship' | 'retireRelationship'>(caseId)
  return (
    <>
      <RelationshipFactsView
        marks={marks}
        pending={dialogs.pending}
        actions={{
          onInvalidate: () => dialogs.open('invalidateRelationship'),
          onRetire: () => dialogs.open('retireRelationship'),
          onRevalidate: () => dialogs.send({ kind: 'revalidateRelationship', id }, 'revalidated'),
          onRestore: () => dialogs.send({ kind: 'restoreRelationship', id }, 'restored'),
        }}
      />
      <MarkDialog
        kind={dialogs.dialog}
        onOpenChange={open => !open && dialogs.close()}
        submit={{
          pending: dialogs.pending,
          error: dialogs.error,
          onSubmit: values =>
            dialogs.dialog === 'retireRelationship'
              ? dialogs.send(
                  { kind: 'retireRelationship', id, body: { reason: values.reason.trim() } },
                  'retired'
                )
              : dialogs.send(
                  { kind: 'invalidateRelationship', id, body: toInvalidateRequest(values) },
                  'invalidated'
                ),
        }}
      />
    </>
  )
}
